import React from 'react';
import Button from '../ui/Button';

export const formatPaymentAmount = (value) => `GH\u00A2${(Number(value) || 0).toFixed(2)}`;

export const getPaymentState = (record) => {
  const amountPaid = Number(record?.amountPaid) || 0;
  const balanceDue = Number(record?.balanceDue) || 0;
  const isFullyPaid = record?.isFullyPaid === true || (amountPaid > 0 && balanceDue <= 0);

  if (isFullyPaid) {
    return { label: 'Paid in full', className: 'bg-success/10 text-success' };
  }
  if (amountPaid > 0) {
    return { label: 'Deposit paid', className: 'bg-primary/10 text-primary' };
  }
  return { label: 'Unpaid', className: 'bg-warning/10 text-warning' };
};

const PaymentSummary = ({ record, totalAmount, onRecordBalance, compact = false }) => {
  const total = Number(totalAmount ?? record?.totalAmount ?? record?.price) || 0;
  const amountPaid = Number(record?.amountPaid) || 0;
  const hasBalanceValue = record?.balanceDue != null;
  const balanceDue = hasBalanceValue ? Number(record.balanceDue) || 0 : Math.max(total - amountPaid, 0);
  const paymentState = getPaymentState({ ...record, amountPaid, balanceDue });

  return (
    <div className={compact ? 'space-y-2' : 'space-y-3'}>
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-muted-foreground font-caption">Payment status</span>
        <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium font-caption ${paymentState.className}`}>
          {paymentState.label}
        </span>
      </div>
      {onRecordBalance && (
        <Button type="button" variant="outline" size="sm" fullWidth iconName="Banknote" onClick={onRecordBalance}>
          Record payment
        </Button>
      )}
      <div className="space-y-2 border-t border-border pt-3 text-sm font-caption">
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Total amount</span>
          <span className="font-medium text-foreground">{formatPaymentAmount(total)}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-muted-foreground">Amount paid</span>
          <span className="font-medium text-success">{formatPaymentAmount(amountPaid)}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="font-medium text-foreground">Balance due</span>
          <span className="font-heading text-lg font-semibold text-foreground">{formatPaymentAmount(balanceDue)}</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
